/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div class="container-fluid">
    <div
      v-if="notification"
      class="row"
      role="complementary"
    >
      <div class="col-md-6 col-md-offset-3">
        <div
          class="alert"
          :class="alertClass"
        >
          <button
            v-if="!notification.sticky"
            id="closeNotificationButton"
            type="button"
            class="close"
            @click="clear"
          >
            &times;
          </button>
          <strong v-if="notification.subject">
            {{ notification.subject }}<br>
          </strong>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="notification.text" />
          <button
            v-if="notification.button && notification.button.action"
            class="btn btn-primary"
            @click.prevent="executeButtonAction"
          >
            {{ (notification.button && notification.button.text) ? notification.button.text : '' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .alert-danger strong {
    color: #D3382F;
  }
  .alert-success strong {
    color: #04D97E;
  }
</style>

<script>
export default {
  computed: {
    notification() {
      return this.$store.getters.notification;
    },
    alertClass() {
      const classes = {};
      if (this.notification) {
        window.scrollTo(0, 0);

        // Push the message to screenreaders
        this.$announcer.set(this.notification.subject + ' ' + this.notification.text);

        const type = this.notification.type;
        if (type === 'error' || type === 'warning') {
          if (type === 'error') {
            // Register the error with Sentry
            let text = this.notification.text.substring(0, 200).replace(/\s/g, ' ');
            if (window.Raven) {
              window.Raven.captureMessage(this.notification.subject, {tags: {text}});
            }
          }
          classes['alert-danger'] = true;

        } else {
          classes['alert-' + type] = true;
        }
        classes['alert-dismissible'] = !this.notification.sticky;
      }
      return classes;
    }
  },
  methods: {
    clear() {
      this.$store.dispatch('clearNotification');
    },
    executeButtonAction() {
      if (this.notification && this.notification.button && this.notification.button.action) {
        this.notification.button.action();
      }
    }
  }
};
</script>
